
import $ from 'jquery';
import Vue from 'vue';
import FileUpload from '../components/FileUpload'
import {TheMask} from 'vue-the-mask'
import moment from 'moment'
moment.locale('en');

const mapBookingTypeToRoomTypeId = {
    adults_single: 1,
    adults_double: 2,
    adults_triple: 5,
    child_withbed: 3,
    child_nobed: 4,
    joinland: 8,
    infant: 6
}

const defalutFormPassenger = {
    domId: "",
    id:"",
    bookingType: "",
    bookingTypeName: "",
    pnrCode:"",
    roomTypeId:null,
    roomType:"",
    name:"",
    lastName:"",
    gender:"",
    region:"",
    genderEN: "",
    sBirthDate:"",
    passportNo:"",
    sPassportExpire:"",
    passportImageUrl:"",
    religionEN:"",
    regionEN:"",
    titleName:"",
    titleNameEN:"",
    firstNameEN:"",
    lastNameEN:"",
    religion:"",
    telNo:"",
    email:"",
    visaNumber:"",
    visaImageUrl:"",
    sPassportEffectiveDate:"",
    mile:"",
    requestMeal:"",
    requestMealOnBoard:"",
    remark:""
}

const defaultFormData = {
    passengers: []
}

if($('#vue-wow-form-passenger').length){
    window.WowFormPassenger = new Vue({
        el: '#vue-wow-form-passenger',
        components: { 
            FileUpload,
            TheMask
        },
        data: {
            pnrcode:  TX_BOOKING_DETAIL_PASSENGER && TX_BOOKING_DETAIL_PASSENGER['pnrcode'] ? TX_BOOKING_DETAIL_PASSENGER['pnrcode'] : null,
            isLoading: true,
            isSuccess: false,
            isSubmiting: false,
            passengersData: null,
            formData: {...defaultFormData},
            dropzoneOptions: {
                url: window.AJAX_URL,
                thumbnailWidth: 150,
                maxFilesize: 0.5,
                addRemoveLinks: true,
                params: {
                    action: 'upload_file_s3'
                },
            }
        },
        async created(){
            try {
                const joinlandId = await new Promise((resolve, reject)=>{
                    $.get(window.AJAX_URL, {
                        dataType: 'json',
                        _wpnonce: AJAX_NONCE,
                        action: 'get_joinland_id',
                    })
                    .done( data => {
                        if (!data.data || !Array.isArray(data.data)) {
                            resolve(null);
                        }else{
                            const joinlandObj = data.data.find( (item) => {
                                return item && item.roomType && item.roomType == "Joinland" ? true : false
                            })
                            const _joinlandId = joinlandObj && joinlandObj.id ? joinlandObj.id : null
                            resolve(_joinlandId);
                        }
                    })
                    .fail( data => {
                        resolve([]);
                    });
                })
    
                if (joinlandId) {
                    mapBookingTypeToRoomTypeId.joinland = joinlandId
                }
            } catch (error) {
                
            }
            this.fetchData();
        },
        mounted() {

        },
        methods: {
            fetchData(){
                this.passengersData = new Promise((resolve, reject)=>{
                    $.get(window.AJAX_URL, {
                        dataType: 'json',
                        _wpnonce: AJAX_NONCE,
                        action: 'get_passenger',
                        pnrcode: this.pnrcode
                    })
                    .done( data => {
                        let passengers = [];
                        if( data.success === true ){
                            passengers = data.data ? data.data : [];
                        }
                        resolve(passengers);
                    })
                    .fail( data => {
                        resolve([]);
                    });
                })
                .then(data => {
                    let passengers = [];
    
                    const cleanValue = data.map( item => {
                        moment.locale('en')
                        return {
                            ...item,
                            sBirthDate: moment(item.sBirthDate, 'DD MMM YY').isValid() ? moment(item.sBirthDate, 'DD MMM YY').format('DD/MM/YYYY') : '',
                            sPassportExpire: moment(item.sPassportExpire, 'DD MMM YY').isValid() ? moment(item.sPassportExpire, 'DD MMM YY').format('DD/MM/YYYY') : '',
                            sPassportEffectiveDate: moment(item.sPassportEffectiveDate, 'DD MMM YY').isValid() ? moment(item.sPassportEffectiveDate, 'DD MMM YY').format('DD/MM/YYYY') : '',
                        }
                    } )
                    
                    Object.keys(mapBookingTypeToRoomTypeId).map( bookingType => {
                        if( TX_BOOKING_DETAIL_PASSENGER[bookingType] && TX_BOOKING_DETAIL_PASSENGER[bookingType] > 0 ){
                            [...Array(TX_BOOKING_DETAIL_PASSENGER[bookingType])].map( (i,index) => {
    
                                const listPassengerByBookingType = cleanValue.filter( initValueData => {
                                    return mapBookingTypeToRoomTypeId[bookingType] === initValueData.roomTypeId;
                                } );
    
                                const passengerData = listPassengerByBookingType[index] ? listPassengerByBookingType[index] : {};
                                
                                passengers.push({
                                    ...defalutFormPassenger,
                                    ...passengerData,
                                    domId: `${index}-${bookingType}`,
                                    bookingType,
                                    bookingTypeName: TX_TOUR_PRICE_LIST_PASSENGER[bookingType] ? TX_TOUR_PRICE_LIST_PASSENGER[bookingType] : '',
                                    roomTypeId: mapBookingTypeToRoomTypeId[bookingType],
                                    pnrCode: this.pnrcode
                                }); 
                            })
                        }
                    } );
    
                    this.formData = {
                        ...defaultFormData,
                        passengers
                    }
                    this.isLoading = false
                    if( this.isSubmiting === true ){
                        this.isSubmiting = false;
                    }
                    // console.log(this.formData);
                });
            },
            onFormDataUpdate(fieldName, fieldValue, fieldGroupIndex){
                // console.log(fieldName, fieldValue, fieldGroupIndex);
                this.formData.passengers[fieldGroupIndex][fieldName] = fieldValue || '';
            },
            onSubmit(e){
                e.preventDefault();
                this.isSubmiting = true;

                const cleanValuePassengers = this.formData.passengers.map( item => {
                    moment.locale('en');
                    return {
                        ...item,
                        genderEN: item.gender,
                        sBirthDate: moment(item.sBirthDate,'DD/MM/YYYY').isValid() ? moment(item.sBirthDate,'DD/MM/YYYY').format('DD MMM YY') : '',
                        sPassportExpire: moment(item.sPassportExpire,'DD/MM/YYYY').isValid() ? moment(item.sPassportExpire,'DD/MM/YYYY').format('DD MMM YY') : '',
                        sPassportEffectiveDate: moment(item.sPassportEffectiveDate,'DD/MM/YYYY').isValid() ? moment(item.sPassportEffectiveDate,'DD/MM/YYYY').format('DD MMM YY') : '',
                    }
                } );

                $.ajax({
                    type: "POST",
                    url: window.AJAX_URL,
                    dataType: 'json',
                    data: {
                        passengers: cleanValuePassengers,
                        action: 'save_passenger',
                        _wpnonce: AJAX_NONCE,
                    },
                    success: (data) => {
                      if( data && data.success === true ){
                          alert('บันทึกข้อมูลสำเร็จ');
                      }else{
                          const errorMessage = data && data.message ? data.message : 'บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ'
                          alert(errorMessage);
                      }
                      this.fetchData();
                    },
                    error: (data) => {
                      alert('บันทึกข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ');
                      //this.fetchData();
                    }
                  })
            }
        }
    })
}